<template>
  <div class="item__form">
    <vs-row>
      <vs-col>
        <h3>Common info</h3>
        <vs-input label="Name" size="large" v-model="name"></vs-input>
        <vs-textarea label="Description" v-model="desc" counter="500"/>

        <h3>Alerts at minimum count</h3>
        <vs-checkbox v-model="is_min_quantity_notify" vs-value="1"
          >Alert</vs-checkbox
        >
        <vs-input
          size="large"
          label="Minimum count"
          v-model="min_count"
        ></vs-input>
      </vs-col>
      <vs-col>
        <div v-if="!item || !item.id">
          <h3>Price details</h3>
          <div class="price-calculator">
            <vs-input
              type="number"
              size="large"
              label="Count"
              v-model="count"
              @input="updatePriceFields($event, 'count')"
            ></vs-input>
            <span> x </span>
            <vs-input
              type="number"
              size="large"
              label="Price per unit"
              v-model="price_per_unit"
              @input="updatePriceFields($event, 'price_per_unit')"
            ></vs-input>
            <span> = </span>
            <vs-input
              type="number"
              size="large"
              label="Total cost"
              v-model="price"
              @input="updatePriceFields($event, 'price')"
            ></vs-input>
          </div>
          <div class="field">
            <label for="">Purchased</label>
            <v-date-picker
              v-model="purchased"
              mode="date"
              ref="calendar"
              label="Purchased"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <div>
                  <vs-input
                    class="calendar-input"
                    :value="`${inputValue}`"
                    v-on="inputEvents"
                    size="large"
                  />
                </div>
              </template>
            </v-date-picker>
          </div>
        </div>
        <h3>Files {{ file_ids.length }}</h3>
        <FilesList :files="files" :isEditable="true" @delete="deleteByIdHandler"/>
        <FileUploadForm
          type="item"
          @successUpload="successUploadHandle"
          @delete="deleteByIdHandler"
        />
      </vs-col>
    </vs-row>

    <div class="save-popup-button">
      <vs-button icon="save" @click="saveItem">Save</vs-button>
    </div>
  </div>
</template>

<script>
import FileUploadForm from '@/components/files/fileUploadForm'
import FilesList from '@/components/files/filesList'

export default {
  name: 'ItemForm',
  props: ['item'],
  data() {
    let data = {
      name: '',
      desc: '',
      is_min_quantity_notify: '',
      min_count: 0,
      count: null,
      price_per_unit: null,
      price: null,
      file_ids: [],
      purchased: new Date(),
      files: [],
    }
    if (this.item && this.item.id) {
      data = { ...this.item }
      if (data.purchased) {
        data.purchased = this.$moment(data.purchased * 1000)
      }
      if (this.item.files) {
        data.file_ids = this.item.files.map((f) => f.id)
      } else {
        data.file_ids = []
      }
    }

    data.uploadedFiles = []
    return { ...data }
  },
  components: { FileUploadForm, FilesList },

  methods: {
    saveItem: function () {
      // TODO: avatar to base64
      let {
        name,
        desc,
        is_min_quantity_notify,
        min_count,
        count,
        price_per_unit,
        price,
        file_ids,
        purchased
      } = this

      const data = {
        name,
        desc,
        is_min_quantity_notify,
        min_count,
        count,
        price_per_unit,
        price,
        file_ids,
        purchased: purchased ? purchased.getTime()/1000 : null
      }

      if (this.id) data.id = this.id
      this.$store
        .dispatch('items/saveItemsAction', {
          item: data,
        })
        .then(() => {
          this.$emit('closePopup', this.closePopup)
        })
    },
    successUploadHandle: function (response) {
      this.uploadedFiles.push(response)
      this.file_ids.push(response.id)
    },
    normalizeNumericValue(value) {
      if (value === '' || value === null || value === undefined) return null
      const parsedValue = parseFloat(value)
      return Number.isNaN(parsedValue) ? null : parsedValue
    },
    updatePriceFields(changedValue, changedField) {
      const count = this.normalizeNumericValue(this.count)
      const pricePerUnit = this.normalizeNumericValue(this.price_per_unit)
      // const price = this.normalizeNumericValue(this.price)

      if (changedField === 'count') {
        if (
          pricePerUnit !== null &&
          pricePerUnit !== undefined &&
          pricePerUnit !== 0
        ) {
          this.price = changedValue * pricePerUnit
        }
      }

      if (changedField === 'price_per_unit') {
        if (count !== null && count !== undefined && count !== 0) {
          this.price = count * changedValue
        }
      }

      if (changedField === 'price') {
        if (count !== undefined && count !== null && count !== 0) {
          this.price_per_unit = Number((changedValue / count).toFixed(2))
        } else if (
          pricePerUnit !== undefined &&
          pricePerUnit !== null &&
          pricePerUnit !== 0
        ) {
          this.count = Number((changedValue / pricePerUnit).toFixed(2))
        }
      }
    },

    deleteByIdHandler: function(file_id){
      // ищем по полученным файлам
      const file = this.files.find(f => f.id == file_id)
      // удаляем из списка идентификаторов для загрузки
      if (file && file.id){
        const file_id_idx = this.file_ids.findIndex(id => id==file_id)
        const exist_file_id_idx = this.files.findIndex(f => f.id==file_id)
        if (file_id_idx != -1){
          this.file_ids.splice(file_id_idx, 1)
        }
        if (exist_file_id_idx != -1){
          this.files.splice(exist_file_id_idx, 1)
        }
      }
      // ищем загруженные файлы
      const uploadedFile = this.uploadedFiles.find(f => f.id == file_id)
      if (uploadedFile && uploadedFile.id){
        const file_id_idx = this.file_ids.findIndex(id => id==uploadedFile.id)
        this.file_ids.splice(file_id_idx, 1)
      }

    }
    // changeFile: function (event, files) {
    //   this.toBase64(files[0]).then((f) => {
    //     this.avatar = f
    //   })
    // },
    // toBase64: function (file) {
    //   return new Promise((resolve, reject) => {
    //     const reader = new FileReader()
    //     reader.readAsDataURL(file)
    //     reader.onload = () => resolve(reader.result)
    //     reader.onerror = (error) => reject(error)
    //   })
    // },
    // avatarClickHandler: function () {
    //   const uploadEl = document.querySelector('.con-input-upload input')
    //   if (uploadEl) uploadEl.click()
    // },
  },
}
</script>

<style lang="scss">
.item__form {
  padding: 0 5px;
  .vs-input {
    width: 100%;
  }
  & > .vs-row {
    flex-flow: row nowrap;
    & > .vs-col {
      flex: 1;
      padding: 1rem;
      margin: 0 1rem;
      box-shadow: 0 0 10px 1px #ddd;
      border-radius: 0.5rem;
    }
  }
  &-header {
    & > * {
      margin-right: 1rem;
    }
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    .vs-input {
      width: 100px;
      margin-top: 0;
    }
  }
  hr {
    margin: 25px 0;
    color: #fff;
    border-color: #fff;
    background-color: #fff;
    border-style: solid;
  }
  h3 {
    margin: 1rem 0 0.5rem 0;
  }
  .price-calculator {
    display: grid;
    gap: 0.75rem;
    margin-top: 0.75rem;
    .vs-input {
      margin-top: 0;
    }
  }
  .con-img-upload {
    margin-top: 0;
  }
  .price-calculator {
    display: flex;
    flex-flow: row nowrap;
    align-items: end;
    span {
      margin-bottom: 1rem;
      font-weight: bold;
    }
  }
}
</style>
